import { render, staticRenderFns } from "./TaskActivity.vue?vue&type=template&id=50150ae8&"
import script from "./TaskActivity.vue?vue&type=script&lang=js&"
export * from "./TaskActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports